import ViewTicketContainer from "./ViewTicketContainer";

export default ViewTicketContainer;